import React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/material";

interface Props {
  label: string;
  description: string;
  checked: boolean;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const CheckItem: React.FC<Props> = ({
  description,
  label,
  checked,
  disabled,
  onChange,
}) => {
  return (
    <Stack>
      <FormControlLabel
        control={
          <Checkbox
            sx={{
              color: "primary",
            }}
            checked={(checked || disabled) ?? false}
            disabled={disabled}
            onChange={onChange ?? (() => {})}
          />
        }
        label={
          <Typography
            variant="bodySmallWeightBold"
            fontWeight={700}
            component="span"
          >
            {label}
          </Typography>
        }
      />
      <Typography variant="bodySmallWeightRegular" pl={"32px"}>
        {description}
      </Typography>
    </Stack>
  );
};

export default CheckItem;
